import { yourAgentEpic as epic } from "./epic";
import { yourAgentReducer as reducer } from "./reducer";

export const yourAgentEpic = epic
export const yourAgentReducer = reducer
